import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";

import { brandsSuggestion, getNewCross, removeCross } from "services/api";
import { MySpinner } from "components/MySpinner";
import { Pagination } from "components/Pagination";
import useQuery from "utils/useQuery";
import { CrossTableNew } from "features/Cross/CrossTableNew";

import "./crossPage.scss";
import { SelectSearch } from "components/SelectSearch";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Trash } from "react-feather";
import { toast } from "react-toastify";
import { AddCrossModal } from "features/Cross/AddCrossModal";


export const CrossNewPage = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const [cross, setCross] = useState([]);
  const [crossCount, setCrossCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    query.get("page") ? Number(query.get("page")) : 1
  );
  const getPageSize = localStorage.getItem("pageSize") ? JSON.parse(localStorage.getItem("pageSize")) : {};
  const [pageSize, setPageSize] = useState(getPageSize[pathname] || 10);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(query.get("search") || "");
  const [brand, setBrand] = useState(
    query.get("brand")
      ? { label: query.get("brandName"), value: query.get("brand") }
      : null
  );
  const [isShowReset, setIsShowReset] = useState(false);
  const [selected, setSelected] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const getAndSetCross = () => {

    if (!isSearch()) return;

    setLoading(true);
    getNewCross({
      article: search,
      brandId: brand?.value
    })
      .then((res) => {
        const arr = [];
        res.forEach(item => {
          item.cross.forEach(item1 => {
            if (!arr.find(v => v.id === item1.id)) {
              arr.push({
                analogueCode: item.analogueCode,
                ...item1
              })
            };
          })
        });
        setCross(arr);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const url = new URLSearchParams();
    if (currentPage !== 1) {
      url.append("page", currentPage);
    }

    if (search) {
      url.append("search", search);
    }

    if (brand?.value) {
      url.append("brand", brand?.value);
      url.append("brandName", brand?.label);
    }

    if (url) {
      history.push(`${pathname}?${url}`);
    } else {
      history.push(pathname);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, search, brand]);

  useEffect(() => {
    getAndSetCross();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  useEffect(() => {
    setIsShowReset(isSearch());
    if (!isSearch()) {
      getAndSetCross();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, brand]);

  const searchHandler = () => {
    if (!isSearch()) return;
    if (currentPage !== 1) {
      setCurrentPage(1);
      return;
    }
    getAndSetCross();
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      searchHandler();
    }
  };

  const isSearch = () => {
    if (search || brand) {
      return true;
    }
    return false;
  };

  const resetFilter = () => {
    setSearch("");
    setBrand(null);
  };

  const removeHandler = (id) => {
    setLoading(true);
    removeCross({ ids: id ? [id] : selected })
      .then((res) => {
        toast.success("Кроссы успешно удалены");
        setSelected([]);
        getAndSetCross();
      })
      .catch((e) => {
        toast.error(e.response?.data?.message)
        setLoading(false);
      });
  };

  return (
    <Container fluid className="p-0 cross">
      {loading && <MySpinner overlay />}
      <Card className="mb-0">
        <CardBody>
          <h1 className="h3 mb-3">Кроссы</h1>
          <Form className="mb-3">
            <Row>

              <Col md={3}>
                <Label>Артикул</Label>
                <Input
                  name="search"
                  placeholder="По артикулу"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyPress={handleKeypress}
                />
              </Col>
              <Col md={3}>
                <Label>Бренд</Label>
                <SelectSearch
                  name="brand"
                  placeholder="Выберите бренд"
                  functionSuggestion={brandsSuggestion}
                  value={brand}
                  setValue={setBrand}
                  isClearable
                />
              </Col>
              <Col>
                <InputGroup className="with-label">
                  {isShowReset && (
                    <Button color="danger" onClick={() => resetFilter()}>
                      <FontAwesomeIcon icon={faWindowClose} />
                    </Button>
                  )}
                  <Button
                    color="primary"
                    onClick={searchHandler}
                    className="button-wide"
                  >
                    Поиск
                  </Button>
                </InputGroup>
              </Col>
            </Row>
          </Form>

          <Link to="/reference/cross/temp" className="btn btn-primary mr-2">
            Загрузить
          </Link>
          <Button
            onClick={() => setOpenModal(true)}
            className=" mr-2"
          >
            Добавить
          </Button>
          {selected.length > 0 &&
            <Button
              onClick={() => removeHandler()}
              color="danger"
            >
              <Trash size="15" /> Удалить
            </Button>
          }
        </CardBody>
      </Card>

      <div>
        <CrossTableNew
          cross={cross}
          setSelected={setSelected}
          removeHandler={removeHandler}
        />

        <AddCrossModal
          article={search}
          brandId={brand?.value}
          cross={cross}
          setOpenModal={setOpenModal}
          openModal={openModal}
          getAndSetCross={getAndSetCross}
        />

        <Card>
          <CardBody>
            <Pagination
              totalCount={crossCount}
              currentPage={currentPage}
              pageSize={pageSize}
              setCurrentPage={setCurrentPage}
              onChangePageSize={setPageSize}
            />
          </CardBody>
        </Card>
      </div>

    </Container>
  );
};
